import { Injectable } from '@angular/core';
import { Http, HttpModule, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/Rx';

@Injectable()
export class HttpClientService {

  requestHeaders = undefined

  constructor(private _http: Http) { }

  public post(url, body, rawError?) : any {
    console.info("Calling post through HTTP Client Service");
    return this._http.post(url, body, this.requestHeaders)
      .map((response: Response) => response.json())
      .catch(rawError ? this.passError : this.handleError);
  }

  public get(url, rawError?) : any {
    console.info("Calling get through HTTP Client Service");
    return this._http.get(url, this.requestHeaders)
      .map((response: Response) => response.json())
      .catch(rawError ? this.passError : this.handleError);
  }

  public delete(url, rawError?) : any {
    console.info("Calling delete through HTTP Client Service");
    return this._http.delete(url, this.requestHeaders)
      .map((response: Response) => response.json())
      .catch(rawError ? this.passError : this.handleError);
  }

  public put(url, body, rawError?) : any {
    console.info("Calling put through HTTP Client Service");
    return this._http.put(url, body, this.requestHeaders)
      .map((response: Response) => response.json())
      .catch(rawError ? this.passError : this.handleError);
  }


  // private method for error handling using an observable
  private handleError(error: Response) {
    console.error('HttpClientService', 'Error in HttpClientService')
    return Observable.throw(error.json().Error || 'Http Client Service error');
  }

  // private method for passing the raw error using an observable
  private passError(error: Response) {
    console.error('HttpClientService', 'Error in HttpClientService')
    return Observable.throw(error || 'Http Client Service error');
  }

}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/http-client-service/http-client-service.service.ts